import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import { Checkbox } from '@connect-x-app/web-ui';
import { HeaderContext } from '@tanstack/react-table';

import { FlexComponent } from '..';

type TableHeaderProps<T, U> = {
  title: string;
  withCheckbox?: boolean;
} & HeaderContext<T, U>;

export const TableHeader = <T, U>({ table, title, withCheckbox = false }: TableHeaderProps<T, U>) => {
  return (
    <FlexComponent alignItems="center" backgroundColor="transparent" flexDirection="row">
      {withCheckbox ? (
        <Checkbox
          checked={table.getIsAllRowsSelected()}
          name="selectAll"
          onChange={value => table.toggleAllRowsSelected(value)}
        />
      ) : null}
      <Text as="span" color={COLORS.zulu.$08} size="XS" uppercase weight="bold" width="partial-width">
        {title}
      </Text>
    </FlexComponent>
  );
};
